import React, { Component } from "react";
// import { clearErrors } from "../../actions/errorsActions";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import Navigate from "../../components/Navigate/Navigate";
import SideMenu from "../../components/layout/SideMenu";
import ReportCard from "../../components/Cards/ReportCard";
import Spinner from "../../components/common/Spinner";
import { getCandidateReports } from "../../actions/candidate/reportActions";
import { Link } from "react-router-dom";

class Reports extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: {},
      reports: [],
      mounted: false,
      reportsMapped: [],
      auth: {},
      errors: {},
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    let update = {};
    if (nextProps.auth) {
      if (nextProps.auth !== prevState.auth) {
        if (!nextProps.auth.isAuthenticated) {
          nextProps.history.push("/login");
        }
        if (nextProps.errors) {
          update.errors = nextProps.errors;
        }
        update.auth = nextProps.auth;
      }
      if (nextProps.reports.reports !== prevState.reports) {
        update.reports = nextProps.reports.reports;

        update.reports = nextProps.reports.reports;
        update.reportsMapped = nextProps.reports.reports;
      }
    }
    return Object.keys(update).length ? update : null;
  }

  componentDidMount() {
    this.props.getCandidateReports();
  }
  render() {
    const { loading } = this.props.reports;
    var content = "";
    if (this.state.reportsMapped === [] || loading) {
      content = <Spinner />;
    } else {
      content = <ReportCard reports={this.state.reportsMapped} />;
    }

    return (
      <div className="grid-menu-container">
        <div className="menu-grid">
          <div className="menu">
            <SideMenu props={this.props} />
          </div>
        </div>
        <div className="main-grid">
          <div className="main">
            <Navigate
              title={"Reports"}
              link={"/dashboard"}
              buttons={[
                <Link to={"/new-report"} className="btn btn-primary">
                  New Report
                </Link>,
              ]}
            />
            {content}
          </div>
        </div>
      </div>
    );
  }
}

Reports.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors,
  reports: state.reports,
});

export default connect(mapStateToProps, { getCandidateReports })(withRouter(Reports));
